<template>
  <div v-if="load" class="pay-loading">
    <div class="loading-content">
      <lottie :options="defaultOptions" :height="60" style="width: 250px" />
    </div>
  </div>
</template>
<script>
  import { bus } from '../main'
  import Lottie from '../Lottie.vue'
  import * as animationData from '../assets/loading.json'

  export default {
    name: 'app',
    components: {
      lottie : Lottie

    },
    data () {
      return {
        load: false,
        defaultOptions: { animationData: animationData.default },
        animationSpeed: 1
      }
    },
    methods: {},
    mounted () {
      bus.$on('show_spinner', (name) => {
        // console.log('bus', name)
        if (name === 'true') {
          this.load = true
        } else {
          this.load = false
        }
        // setTimeout(this.load = name , 1000)
      })
    }
  }
</script>
<style>
  .pay-loading {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(199, 199, 199, 0.75);
    backdrop-filter: blur(1px);
    height: 100vh;
    width: 100vw;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  
  .loading-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .spinner-border {
    width: 4rem;
    height: 4rem;
    border: 0.25em solid #3c8dbc;
    border-right-color: #17495f;
  }
</style>
